import { motion } from "framer-motion";
import { useRef } from "react";

import { Attribute } from "../../../gql/graphql";
import {
  ROTATE_RANGE,
  CARD_EXIT_TRANSFORM_X,
  CARD_EXIT_ROTATE_RANGE,
  CARD_EXIT_DURATION,
  CARD_EXIT_SCALE,
  CARD_EXIT_TRANSFORM_DURATION,
} from "../../../constants";
import { Content } from "./Content";
import { Overlay } from "./Overlay";
import { useAnswerResult } from "../../../hooks/useAnswerResult";
import { CardState } from "./Content/Content";

import styles from "./Card.module.scss";

interface ExitSwiperCardProps {
  attribute: Attribute;
  exitX: number;
  result: boolean | undefined;
  showIcons?: boolean;
}

export const ExitSwiperCard = ({ attribute, exitX, showIcons, result }: ExitSwiperCardProps) => {
  const windowWidth = useRef(window.innerWidth);
  const { answers } = useAnswerResult();
  const isResultProvided = result !== undefined;

  if (!isResultProvided) {
    result = answers[attribute.id];
  }

  const variantName = isResultProvided ? "side" : "center";

  const cardExitX = windowWidth.current / 2 + 500;
  const xEnd = result ? cardExitX : -cardExitX;
  const xTransformEnd = exitX + (result ? CARD_EXIT_TRANSFORM_X : -CARD_EXIT_TRANSFORM_X);
  const rotation = result ? ROTATE_RANGE : -ROTATE_RANGE;
  const exitRotation = result ? CARD_EXIT_ROTATE_RANGE : -CARD_EXIT_ROTATE_RANGE;

  const variantsCommon = {
    zIndex: 100,
    x: [exitX, xTransformEnd, xEnd],
    transition: {
      duration: CARD_EXIT_DURATION,
      ease: "easeIn",
      times: [0, CARD_EXIT_TRANSFORM_DURATION, CARD_EXIT_DURATION],
    },
  };

  const variants = {
    center: {
      ...variantsCommon,
      rotate: [0, rotation, exitRotation, exitRotation],
      scale: [1, 1, CARD_EXIT_SCALE, CARD_EXIT_SCALE],
    },
    side: {
      ...variantsCommon,
      rotate: [rotation, exitRotation],
      scale: [1, CARD_EXIT_SCALE],
    },
  };

  return (
    <motion.div
      variants={variants}
      className={styles.base}
      initial={{
        x: exitX,
        rotate: isResultProvided ? rotation : 0,
      }}
      animate={variantName}
    >
      <Content attribute={attribute} initial={CardState.Normal} isReversed={false}>
        <Overlay initialAnimation={!isResultProvided} showIcons={showIcons} overwrite={result ? "right" : "left"} />
      </Content>
    </motion.div>
  );
};
